export function formatCurrency(value: number): string {
	return value.toLocaleString('en-US', { currency: 'USD', style: 'currency', minimumFractionDigits: 2 });
}
